import BaseNav from "./dashboard/sub-components/BaseNav";
import Header from "./dashboard/sub-components/Header";
import ".././styles/marketplace.css"
import {useNavigate} from "react-router-dom";
import { de_encrypt,encrypt } from "../encryption";
import {useState} from 'react';
import { auth, db } from './dashboard/firebase/firebase';
import {getDoc,doc,updateDoc} from 'firebase/firestore'
const ViewAds = ({ user }) => {
    const user_key=de_encrypt(localStorage.getItem('user-key'));
    const navigate = useNavigate();
    const [exec,setExec] = useState(false);
    const data = JSON.parse(de_encrypt(localStorage.getItem("ad")));
    const [adMain,setAdMain]=useState(null);
    // console.log(data)
     if(!data.engagements.includes(user_key) && !exec){
     ( async ()=>{
     const docRef = doc(db, "ads", data.id);
     const docSnap = await getDoc(docRef);
     const current_data=docSnap.data();
     localStorage.setItem("ad",encrypt(JSON.stringify(current_data)))
     const up_data = {engagements:[...current_data.engagements,user_key]}
     await updateDoc(docRef, up_data);
     setExec(true)
      })();
    }
     const adSession = JSON.parse(de_encrypt(localStorage.getItem(encrypt("adSession"))));
    if(!(adSession.adsViewed.includes(data.id))){
     adSession.adsViewed.push(data.id)
     localStorage.setItem(encrypt("adSession"),encrypt(JSON.stringify(adSession)));
    }
    return (
        <div className="dashboard marketplace-container utility">
            {user && <Header />}
            {user && <BaseNav active={"Marketplace"} />}
            {
              !user &&  <header>
              <div className="container">
                  <div className="left">
                      <p className="logo-db">Viralclicks<span>-mine</span></p>
                  </div>
                  <div className="right">
                     <button onClick={()=> navigate("/")}>Join Viralclicks</button>
                  </div>
              </div>
             </header>
            }
           
            <div className="container">
  
                <div className="ad-view-container">
                     <img src={data.image} />
                     <p className="color-typo"><strong>{data.creator} </strong>{data.caption}</p>
                     <span className="ad-category">{data.category}</span>
                      <a href={`${data.link}`}>Click here for further engagement </a>
  
                </div>
            </div>
        </div>
    );
}

export default ViewAds;
